import React from "react";
import { useSpring, animated } from "react-spring";

const Modal = ({ show, onClose, children }) => {
  const animation = useSpring({
    transform: show ? "translateY(0%)" : "translateY(100%)",
    opacity: show ? 1 : 0,
  });

  return (
    <>
      {show && (
        <div className="fixed inset-0 z-30 flex items-center justify-center max-w-[520px] mx-auto">
          <animated.div
            className="fixed inset-0 bg-black bg-opacity-60"
            onClick={onClose}
          ></animated.div>
          <animated.div
            style={animation}
            className="bg-white p-6 rounded-md shadow-lg w-full relative"
          >
            {children}
          </animated.div>
        </div>
      )}
    </>
  );
};

export default Modal;